import { Icon } from '@iconify/react';
import AppTooltip from './AppTooltip';

const tones = {
  edit: 'tw-border-indigo-200 tw-bg-indigo-50 tw-text-indigo-700 hover:tw-bg-indigo-100',
  danger: 'tw-border-rose-200 tw-bg-rose-50 tw-text-rose-700 hover:tw-bg-rose-100',
  analytics: 'tw-border-sky-200 tw-bg-sky-50 tw-text-sky-700 hover:tw-bg-sky-100',
  success: 'tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100',
  warning: 'tw-border-amber-200 tw-bg-amber-50 tw-text-amber-700 hover:tw-bg-amber-100',
  neutral: 'tw-border-slate-200 tw-bg-slate-50 tw-text-slate-600 hover:tw-bg-slate-100',
};

export default function ActionIconButton({ icon, label, tooltip, title, tone = 'neutral', onClick, disabled = false, loading = false, staticStatus = false, ...props }) {
  const description = tooltip || title || label;
  const className = `tw-inline-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-p-0 tw-transition-colors focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-indigo-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-40 ${tones[tone] || tones.neutral}`;
  const content = loading
    ? <span className="tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-current tw-border-r-transparent" role="status" aria-label="Loading" />
    : <Icon icon={icon} width="19" height="19" aria-hidden="true" />;

  if (staticStatus) {
    return (
      <AppTooltip content={description}>
        <span className={className} role="img" aria-label={label || description}>
          {content}
        </span>
      </AppTooltip>
    );
  }

  const button = (
    <button
      {...props}
      type="button"
      className={className}
      aria-label={label || description}
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );

  return disabled ? (
    <AppTooltip content={description}>
      <span className="tw-inline-flex tw-h-9 tw-w-9 tw-shrink-0 tw-rounded-lg focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-indigo-500" tabIndex={0} aria-label={description}>
        {button}
      </span>
    </AppTooltip>
  ) : (
    <AppTooltip content={description}>{button}</AppTooltip>
  );
}
